// Dealer related calls and methods
const axios = require('axios');
require('es6-promise').polyfill();
const { productDivisionCode } = require('../data/placeHolderCopy');
const dealerEndpoint = require('../data/placeHolderCopy').labels.dealer.endpoint;

const dlrEndpt = window.raq && window.raq.labels && window.raq.labels.dealer.endpoint
                  && window.raq.labels.dealer ? window.raq.labels.dealer.endpoint : dealerEndpoint;
const divCode = window.raq && window.raq.productDivisionCode
  ? window.raq.productDivisionCode : productDivisionCode;

function fetchDealers(endpoint, args) {
  return axios.get(endpoint + args)
    .then((response) => response);
}

function mapDealer(data) {
  const dealerData = data.Dealers ? data.Dealers[0] : data;
  return {
    dealerId: dealerData.DealerNumber,
    name: dealerData.Name,
    phone: dealerData.Phone,
    address: dealerData.Address,
    city: dealerData.City,
    state: dealerData.State,
    zip: dealerData.ZipCode,
  };
}

function getDealer(dealerId) {
  const fetchDealerUrl = `${dlrEndpt}?productDivisionCode=${divCode}&number=${dealerId}`;
  return fetchDealers(fetchDealerUrl, '')
    .then((response) => {
      const dealer = mapDealer(response.data);
      return dealer;
    })
    .catch();
}

function getFirstDealerByZipcode(zipcode, preferedDealer = undefined) {
  let fetchDealerUrl = `${dlrEndpt}?productDivisionCode=${divCode}&zip=${zipcode}&maxResults=16`;

  if (preferedDealer !== undefined) {
    fetchDealerUrl = `${fetchDealerUrl}&number=${preferedDealer}`;
  }
  return fetchDealers(fetchDealerUrl, '')
    .then((response) => {
      const dealer = mapDealer(response.data);
      return dealer || dealer[0];
    })
    .catch();
}

const dealers = {
  getDealer,
  mapDealer,
  getFirstDealerByZipcode,
};

module.exports = dealers;
